var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ContactInfoWrapper } from '../../wrappers';
import { Cart, CartItemSlot } from '../useCart';
import CoinEvents from './Coin';
import CoinUserEventHandlerBase from './CoinUserEventHandlerBase';
import TestData from './TestData';
class CoinEventHandler extends CoinUserEventHandlerBase {
    constructor() {
        super(...arguments);
        this.events = new CoinEvents();
    }
    contactInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            const contactInfo = new ContactInfoWrapper().load();
            const data = contactInfo.getSanitizedData();
            yield this.events.contactInfoComplete().send(this.buildCustomProperties(data));
        });
    }
    addressInfoComplete(addressInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events
                .addressInfoComplete()
                .send(this.buildCustomProperties(Object.assign({}, addressInfo)));
        });
    }
    paymentInfoComplete() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.paymentInfoComplete().send(this.buildCustomProperties());
        });
    }
    addToCart() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.addToCart().send(this.buildCartProperties());
        });
    }
    purchaseCompleted(payment) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.purchase().send(this.buildCartProperties({
                rid: (_c = (_b = (_a = payment.data) === null || _a === void 0 ? void 0 : _a.checkout) === null || _b === void 0 ? void 0 : _b.customer) === null || _c === void 0 ? void 0 : _c.id,
                txid: (_f = (_e = (_d = payment.data) === null || _d === void 0 ? void 0 : _d.checkout) === null || _e === void 0 ? void 0 : _e.transaction) === null || _f === void 0 ? void 0 : _f.id,
            }));
        });
    }
    userClick(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.userClick().send(this.buildCustomProperties(fields));
        });
    }
    initiateCheckout() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.initiateCheckout().send(this.buildCartProperties());
        });
    }
    purchaseAttempted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.transactionAttempted().send(this.buildCustomProperties());
        });
    }
    purchaseFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.transactionFailed().send(this.buildCustomProperties());
        });
    }
    upsellViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellViewed().send(this.buildCustomProperties());
        });
    }
    trialStarted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.trialStarted().send(this.buildCustomProperties());
        });
    }
    upsellUnavailable() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellUnavailable().send(this.buildCustomProperties());
        });
    }
    upsellAccepted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellAccepted().send(this.buildCustomProperties());
        });
    }
    upsellSucceeded() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Promise.all([
                this.events.purchase().send(this.buildUpsellProperties()),
                this.events.upsellSucceeded().send(this.buildCustomProperties()),
            ]);
        });
    }
    upsellFailed() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.upsellFailed().send(this.buildCustomProperties());
        });
    }
    viewContent(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.viewContent().send(this.buildCustomProperties(fields));
        });
    }
    testStarted(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.testStarted().send(this.buildCustomProperties(fields));
        });
    }
    funnelStarted(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.funnelStarted().send(this.buildCustomProperties(fields));
        });
    }
    emailCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.emailCollected().send(this.buildCustomProperties(fields));
        });
    }
    accountCreated() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.accountCreated().send(this.buildCustomProperties());
        });
    }
    shareCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.shareCompleted().send(this.buildCustomProperties());
        });
    }
    buyticketsCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.buyticketsCompleted().send(this.buildCustomProperties());
        });
    }
    installCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.installCompleted().send(this.buildCustomProperties());
        });
    }
    funnelCompleted() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.funnelCompleted().send(this.buildCustomProperties());
        });
    }
    offerRequested(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.offerRequested().send(this.buildCustomProperties(fields));
        });
    }
    feedbackScoreCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.feedbackScoreCollected().send(this.buildCustomProperties(fields));
        });
    }
    feedbackSourceCollected(fields) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.feedbackSourceCollected().send(this.buildCustomProperties(fields));
        });
    }
    goodFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.goodFeedbackRequested().send(this.buildCustomProperties());
        });
    }
    badFeedbackRequested() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.events.badFeedbackRequested().send(this.buildCustomProperties());
        });
    }
    buildCartProperties(data) {
        var _a;
        const content_ids = [];
        const contents = [];
        const cart = Cart.get();
        for (const item of (_a = cart === null || cart === void 0 ? void 0 : cart.getItems()) !== null && _a !== void 0 ? _a : []) {
            content_ids.push(item.planId);
            contents.push({
                id: item.planId,
                quantity: 1,
            });
        }
        return Object.assign(Object.assign(Object.assign(Object.assign({}, data), this.buildValueProperties(data)), this.buildContentProperties(data)), { content_ids,
            contents, num_items: content_ids.length });
    }
    buildUpsellProperties(data) {
        var _a;
        const content_ids = [];
        const contents = [];
        const item = Cart.get().getItemsBySlot(CartItemSlot.Upsell);
        if (item) {
            content_ids.push(item.planId);
            contents.push({
                id: item.planId,
                quantity: 1,
            });
        }
        return Object.assign(Object.assign(Object.assign({}, data), this.buildContentProperties(data)), { content_ids,
            contents, currency: 'USD', num_items: content_ids.length, value: (_a = item === null || item === void 0 ? void 0 : item.value) !== null && _a !== void 0 ? _a : 0 });
    }
    buildContentProperties(data) {
        const cart = Cart.get();
        return Object.assign(Object.assign(Object.assign({}, data), this.buildCustomProperties(data)), { content_name: cart.getItemSet(), content_type: 'product' });
    }
    buildValueProperties(data) {
        const cart = Cart.get();
        return Object.assign(Object.assign(Object.assign({}, data), this.buildCustomProperties(data)), { currency: 'USD', value: cart.getValue() });
    }
    buildCustomProperties(data) {
        const cart = Cart.get();
        const testData = new TestData().data;
        return Object.assign(Object.assign({}, data), { itemSet: cart.getItemSet(), testData });
    }
}
export default CoinEventHandler;
//# sourceMappingURL=CoinEventHandler.js.map